import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export default function NotificationSlider() {
    const NOTIFICATIONS = [
        {
            href: "#",
            title: "Ưu đãi đặc biệt",
            content: `🌟 Đón Xuân rộn ràng – Trúng iPhone 17!

Lên đơn từ 4,5 triệu nhận mã dự thưởng với cơ hội trúng iPhone 17, iPad Gen 11, máy hút bụi, vali, nồi chiên & nhiều quà xịn.
Mua 350K Sản phẩm Buymed tuyển chọn để nhận thêm 1 mã thưởng nữa.

👉 Xem chi tiết tại: https://bit.ly/44viWOp`,
            time: "12 giờ trước",
        },
        {
            href: "/users/loyalty_points?type=1",
            title: "Tích điểm đổi quà hấp dẫn",
            content:
                "Mua sắm ngay hôm nay để nhận điểm thưởng cho mỗi đơn hàng và đổi lấy những phần quà giá trị!",
        },
        {
            href: "/products",
            title: "Ưu đãi hấp dẫn cho bạn",
            content:
                "Chào nhà thuốc! Khám phá trải nghiệm mua sắm tại thuocsi.vn và nhận những ưu đãi đặc biệt ngay hôm nay!",
        },
        {
            href: "/khuyen-mai",
            title: "Khám phá sản phẩm khuyến mãi",
            content:
                "Tìm hiểu ngay những sản phẩm vừa được cập nhật, phù hợp với nhu cầu của bạn. Nhấn vào đây để khám phá ngay!",
        },
    ];

    const containerRef = useRef<HTMLDivElement>(null);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const [canScrollLeft, setCanScrollLeft] = useState(false);

    const CARD_WIDTH = 320; // ~300 + gap

    const checkScroll = () => {
        const el = containerRef.current;
        if (!el) return;

        setCanScrollLeft(el.scrollLeft > 10);

        setCanScrollRight(
            el.scrollLeft + el.clientWidth < el.scrollWidth - 10
        );
    };

    useEffect(() => {
        checkScroll();
    }, []);

    const scrollPrev = () => {
        containerRef.current?.scrollBy({
            left: -CARD_WIDTH,
            behavior: "smooth",
        });
    };

    const scrollNext = () => {
        containerRef.current?.scrollBy({
            left: CARD_WIDTH,
            behavior: "smooth",
        });
    };

    return (
        <div
            id="BLOCK_NOTIFICATION"
            event-block="BLOCK_NOTIFICATION"
            className="pt-3 rounded-[10px] w-full relative bg-gradient"
        >
            <h2 className="font-semibold text-2xl px-5 text-white">
                Cập nhật mới nhất
            </h2>

            <div className="relative">
                {canScrollLeft && (
                    <button
                        type="button"
                        onClick={scrollPrev}
                        className="MuiButtonBase-root MuiIconButton-root absolute sm:left-[-14px] left-[0px] top-1/2 transform -translate-y-1/2 z-10"
                    >
                        <svg
                            className="MuiSvgIcon-root text-slate-500"
                            viewBox="0 0 24 24"
                        >
                            <path d="M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm10-1h4v2h-4v3l-4-4 4-4v3z" />
                        </svg>
                    </button>
                )}

                <div
                    ref={containerRef}
                    onScroll={checkScroll}
                    className="
                        scrollbar-0
                        overflow-x-auto
                        flex gap-5
                        pb-6 pt-2
                        px-5
                        snap-x snap-mandatory
                    "
                >
                    {NOTIFICATIONS.map((item, index) => (
                        <Link key={index} to={item.href}>
                            <div
                                className="
                                bg-white rounded-[10px] p-4
                                min-w-[300px] max-w-[300px]
                                min-h-[160px] max-h-48
                                flex flex-col gap-2
                                transition
                                hover:scale-105 hover:shadow-lg
                                "
                            >
                                <h2 className="text-lg font-semibold line-clamp-1">
                                    {item.title}
                                </h2>

                                <p className="line-clamp-3 whitespace-pre-line">
                                    {item.content}
                                </p>

                                {item.time && (
                                    <span className="text-[#797979] text-[10px] mt-auto">
                                        {item.time}
                                    </span>
                                )}
                            </div>
                        </Link>
                    ))}
                </div>

                {/* ARROW RIGHT */}
                {canScrollRight && (
                    <button
                        type="button"
                        onClick={scrollNext}
                        className="MuiButtonBase-root MuiIconButton-root absolute sm:right-[-14px] right-[0px] top-1/2 transform -translate-y-1/2"
                    >
                        <svg
                            className="MuiSvgIcon-root text-slate-500"
                            viewBox="0 0 24 24"
                        >
                            <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-10 1H8v-2h4V8l4 4-4 4v-3z" />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
}
